import { computed, inject, Injectable } from '@angular/core';
import { type UserRole, roles as ROLE_ORDER } from '@shared/models/auth';
import { AuthService } from './auth.service';
import type { User } from '@shared/models/user';

@Injectable({ providedIn: 'root' })
export class AuthUser {
  readonly #auth = inject(AuthService);

  readonly data = computed(() => {
    if (this.#auth.user.hasValue()) {
      return this.#auth.user.value();
    }
    return null;
  });

  /** A set of branches the user has access to */
  readonly branches = computed(() => {
    const roles = this.data()?.roles || [];

    return roles.reduce((acc, role) => {
      for (const shop of role.shops) {
        acc.add(shop);
      }
      return acc;
    }, new Set<string>());
  });

  isSame(user: User): boolean {
    return this.data()?.id === user.id;
  }
}
